import script from "./reinstate.vue?vue&type=script&lang=js&setup=true"
export * from "./reinstate.vue?vue&type=script&lang=js&setup=true"

import "./reinstate.vue?vue&type=style&index=0&id=41df43a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41df43a0"]])

export default __exports__